import React, { useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { useDistributionNormalUIContext } from "./NormalUIContext";
import DistributionNormalTable from "./normal-table/NormalTable";
import { DistributionNormalFilter } from "./normal-filter/NormalFilter";
import { BlockOrg, RoleChecker } from "../../../../RoleChecker";
import { DistributionNormalEditForm } from "./normal-edit-dialog/NormalEditForm";
import { useDispatch } from "react-redux";
import * as actions from "../_redux/normalAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import ConfirmationModal from "../../../../../_metronic/layout/components/confirmation-modal/ConfirmationModal";

export const DistributionNormalCard = ({ history }) => {
  const dispatch = useDispatch();

  // ? DATA FOR FILTER
  const [currentData, setCurrentData] = useState({
    thk_livestock_uuid: "",
    limit: "",
    name: "",
    donation_hid: "",
    is_merging: false,
  });

  const getDistributionList = () => {
    dispatch(actions.fetchDistributionNormals(currentData));
  };

  // ? DATA FOR DISTRIBUTION
  const [distributionData, setDistributionData] = useState({
    thk_livestock_uuid: "",
    thk_area_uuid: "",
    thk_partner_uuid: "",
    is_merging: false,
    donation_item_uuids: [],
  });

  const submitDistribution = () => {
    dispatch(actions.submitDistribution(distributionData)).then((res) => {
      setConfirmationModal(false);
      toast.success("Berhasil mendistribusikan donasi!", toastOption);
      history.push("/kurban/distribution/normal");
    });
  };

  // * MODAL
  const [confirmationModal, setConfirmationModal] = useState(false);

  return (
    <>
      <ConfirmationModal
        show={confirmationModal}
        onHide={() => setConfirmationModal(false)}
        title="Distribusikan Donasi"
        content={`Anda yakin ingin mendistribusikan ${distributionData.donation_item_uuids.length} donasi?`}
        type="info"
        onClick={submitDistribution}
      />
      <Card>
        <CardHeader title="Pendistribusian" />
        <CardBody>
          <DistributionNormalFilter
            // ? DATA FOR FILTER
            currentData={currentData}
            setCurrentData={setCurrentData}
            // ? DATA FOR DISTRIBUTION
            distributionData={distributionData}
            setDistributionData={setDistributionData}
            // ? STOCK
          />
        </CardBody>
      </Card>
      <DistributionNormalEditForm
        setCurrentData={setCurrentData}
        currentData={currentData}
        onSubmit={getDistributionList}
      />
      <Card>
        <CardHeader title="List Pendistribusian" />
        <CardBody>
          <DistributionNormalTable
            distributionData={distributionData}
            setDistributionData={setDistributionData}
            onSubmit={() => setConfirmationModal(true)}
          />
        </CardBody>
      </Card>
    </>
  );
};
